import React, { useEffect } from 'react'
import { callTeamTodayByCreatedateReport, extractTeamCampaign, calcHierarchyEle, buildHierarchy, sumHierarchy, calcHierarchy } from '../../../services/reports/TeamCampaignTodayReportService'
import { resetWindow } from '../../../services/UtilService'
import TeamTodayReportComponent from '../TeamTodayReport/TeamTodayReportComponent'

const TeamCampaignDistTodayReport = (props) => {

    useEffect(() => {
        resetWindow()
    }, [])

    return <React.Fragment>
        <TeamTodayReportComponent
            buildHierarchy={buildHierarchy}
            sumHierarchy={sumHierarchy}
            calcHierarchy={calcHierarchy}
            extractTeam={extractTeamCampaign}
            calcHierarchyEle={calcHierarchyEle}
            callTeamReport={callTeamTodayByCreatedateReport}>
        </TeamTodayReportComponent>
    </React.Fragment>
}

export default TeamCampaignDistTodayReport